module.exports = __webpack_public_path__ + "static/img/XB50.1c10f08.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/XB50.png
// module id = oKVB
// module chunks = 2